/* eslint-disable */
import { useState, createContext, useEffect } from "react";

/*import url and gateway methods */
// import { getData, putData } from "utils/Gateway";
// import * as url from "helper/UrlHelper";

export const GlobalProvider = createContext();

const GlobalContext = (props) => {
  /*======= login requirement start =======*/
  const [createAccountMessage, setcreateAccountMessage] = useState("");
  const [userEmailforOtp, setuserEmailforOtp] = useState("");
  /*======= login requirement end =======*/

  let screenHeight = window.innerHeight;

  return (
    <GlobalProvider.Provider
      value={{
        /* ============== screen height ============================*/
        screenHeight,
        /*======= login requirement start =======*/
        createAccountMessage,
        setcreateAccountMessage,
        userEmailforOtp,
        setuserEmailforOtp,
        /*======= login requirement end =======*/
      }}
    >
      {props.children}
    </GlobalProvider.Provider>
  );
};

export default GlobalContext;
